import { FC } from 'react';
import styled, { css } from 'styled-components';
import Checkbox from './Checkbox';

const Container = styled.label`
  display: flex;
  align-items: flex-start;
  label {
    margin-right: 0.75rem;
  }
`;

const ComponentWithProps: FC<{ readOnly?: boolean }> = ({
  /* eslint-disable @typescript-eslint/no-unused-vars */
  readOnly,
  ...props
}) => {
  return <div {...props} />;
};
const Label = styled(ComponentWithProps)`
  ${({ readOnly }) =>
    readOnly
      ? css`
          cursor: default;
        `
      : css`
          cursor: pointer;
        `}
`;

type LabelledCheckboxProps = {
  label: string | React.ReactElement;
  name?: string;
  checked?: boolean;
  readOnly?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
};

const LabelledCheckbox: FC<LabelledCheckboxProps> = ({
  label,
  name,
  checked,
  onChange,
  readOnly,
  value,
}) => {
  return (
    <Container>
      <Checkbox
        checked={checked}
        onChange={onChange}
        name={name}
        readOnly={readOnly}
        value={value}
      />
      <Label readOnly={readOnly}>{label}</Label>
    </Container>
  );
};

export default LabelledCheckbox;
